/**
 * @generated SignedSource<<ae290206468ba145788e400ea1901961>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HubStatus = "OFFLINE" | "ONLINE" | "%future added value";
export type lockB2CRentalsQuery$variables = {
  hubName: string;
  oneHour: any;
  twoHours: any;
};
export type lockB2CRentalsQuery$data = {
  readonly b2CLockOutstandingSessions: ReadonlyArray<{
    readonly amountCollected: number;
    readonly finalAmount: number | null | undefined;
    readonly id: string;
  }>;
  readonly b2CLockReservations: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"MyLocksTabsOwnedFragment">;
    }>;
  };
  readonly hubMeta: {
    readonly hub: {
      readonly id: string;
      readonly status: HubStatus;
    };
    readonly id: string;
    readonly name: string;
  };
  readonly myUtilizationGrants: {
    readonly nodes: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"MyLocksTabsFragment">;
    }>;
  };
  readonly oneHourEstimate: any;
  readonly twoHoursEstimate: any;
};
export type lockB2CRentalsQuery = {
  response: lockB2CRentalsQuery$data;
  variables: lockB2CRentalsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "oneHour"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "twoHours"
  }
],
v1 = {
  "alias": "oneHourEstimate",
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "until",
          "variableName": "oneHour"
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ],
  "kind": "ScalarField",
  "name": "b2CLockSessionFeeEstimate",
  "storageKey": null
},
v2 = {
  "alias": "twoHoursEstimate",
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "until",
          "variableName": "twoHours"
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ],
  "kind": "ScalarField",
  "name": "b2CLockSessionFeeEstimate",
  "storageKey": null
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v4/*:: as any*/),
    (v6/*:: as any*/)
  ],
  "storageKey": null
},
v8 = {
  "kind": "Literal",
  "name": "pagination",
  "value": {
    "page": 0,
    "pageSize": 1000
  }
},
v9 = [
  {
    "kind": "Literal",
    "name": "input",
    "value": {}
  },
  (v8/*:: as any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finalAmount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountCollected",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "B2ClockSession",
  "kind": "LinkedField",
  "name": "b2CLockOutstandingSessions",
  "plural": true,
  "selections": [
    (v4/*:: as any*/),
    (v10/*:: as any*/),
    (v11/*:: as any*/)
  ],
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "subtype": "B2C"
    }
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      {
        "field": "STARTED_AT",
        "ordering": "DESC"
      }
    ]
  },
  (v8/*:: as any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deactivatedAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentNote",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v18 = [
  (v4/*:: as any*/)
],
v19 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "createdByUserId",
      "plural": false,
      "selections": (v18/*:: as any*/),
      "storageKey": null
    }
  ],
  "type": "B2BlockReservationSubtype",
  "abstractKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v18/*:: as any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rentalStartedAt",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frame",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "services",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAt",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v31 = {
  "alias": "lastUnlock",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "status": "UNLOCKED"
      }
    },
    {
      "kind": "Literal",
      "name": "orderBy",
      "value": [
        {
          "field": "CREATED_AT",
          "ordering": "DESC"
        }
      ]
    },
    {
      "kind": "Literal",
      "name": "pagination",
      "value": {
        "page": 0,
        "pageSize": 1
      }
    }
  ],
  "concreteType": "UnlockRequestPage",
  "kind": "LinkedField",
  "name": "unlockRequests",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UnlockRequest",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unlockedAt",
          "storageKey": null
        },
        (v30/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "unlockRequests(filter:{\"status\":\"UNLOCKED\"},orderBy:[{\"field\":\"CREATED_AT\",\"ordering\":\"DESC\"}],pagination:{\"page\":0,\"pageSize\":1})"
},
v32 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Int"
},
v33 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "Int"
},
v34 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v35 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "String"
},
v36 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "DateTime"
},
v37 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "DateTime"
},
v38 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UnlockRequestPage"
},
v39 = {
  "enumValues": null,
  "nullable": false,
  "plural": true,
  "type": "UnlockRequest"
},
v40 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Space"
},
v41 = {
  "enumValues": [
    "BACE_STOREFRONT_S",
    "BACE_STOREFRONT_M",
    "BACE_STOREFRONT_L",
    "BACE_STOREFRONT_XL",
    "BACE_STOREFRONT_2XL",
    "BACE_SATELLITE_SMALL_STANDARD",
    "BACE_SATELLITE_SMALL_SLIM",
    "BACE_SATELLITE_SMALL_EXTENDED",
    "BACE_SATELLITE_MEDIUM_STANDARD",
    "BACE_SATELLITE_MEDIUM_EXTENDED",
    "BACE_SATELLITE_LARGE_STANDARD",
    "BACE_SATELLITE_LARGE_EXTENDED",
    "BACE_CLATTERING_STANDARD",
    "BACE_TRUCK_HUB_STANDARD",
    "THALIA_RENZ_STANDARD_XS",
    "THALIA_RENZ_STANDARD_S",
    "THALIA_RENZ_STANDARD_M",
    "THALIA_RENZ_WIDE_S",
    "THALIA_RENZ_WIDE_M"
  ],
  "nullable": false,
  "plural": false,
  "type": "SpaceConfiguration"
},
v42 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v43 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Hub"
},
v44 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "HubMeta"
},
v45 = {
  "enumValues": [
    "INSTANT_BUY",
    "ONEDELIVERY",
    "CLICK_N_COLLECT",
    "RAFFLE",
    "LOCK_B2B",
    "LOCK_B2C",
    "SHOP_N_COLLECT"
  ],
  "nullable": false,
  "plural": true,
  "type": "HubService"
},
v46 = {
  "enumValues": [
    "ONLINE",
    "OFFLINE"
  ],
  "nullable": false,
  "plural": false,
  "type": "HubStatus"
},
v47 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "LockReservationSubtype"
},
v48 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "B2ClockSession"
},
v49 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "User"
},
v50 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "User"
},
v51 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Float"
},
v52 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "JSONObject"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "lockB2CRentalsQuery",
    "selections": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v3/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v4/*:: as any*/),
            (v5/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v7/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      {
        "alias": null,
        "args": (v9/*:: as any*/),
        "concreteType": "UtilizationGrantPage",
        "kind": "LinkedField",
        "name": "myUtilizationGrants",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UtilizationGrant",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MyLocksTabsFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "myUtilizationGrants(input:{},pagination:{\"page\":0,\"pageSize\":1000})"
      },
      (v12/*:: as any*/),
      {
        "alias": "b2CLockReservations",
        "args": (v13/*:: as any*/),
        "concreteType": "LockReservationPage",
        "kind": "LinkedField",
        "name": "lockReservations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LockReservation",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MyLocksTabsOwnedFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "lockReservations(filter:{\"subtype\":\"B2C\"},orderBy:[{\"field\":\"STARTED_AT\",\"ordering\":\"DESC\"}],pagination:{\"page\":0,\"pageSize\":1000})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "lockB2CRentalsQuery",
    "selections": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*:: as any*/),
        "concreteType": "UtilizationGrantPage",
        "kind": "LinkedField",
        "name": "myUtilizationGrants",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UtilizationGrant",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              (v14/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LockReservation",
                "kind": "LinkedField",
                "name": "reservation",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  (v14/*:: as any*/),
                  (v15/*:: as any*/),
                  (v16/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "subtype",
                    "plural": false,
                    "selections": [
                      (v17/*:: as any*/),
                      (v19/*:: as any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v20/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "B2ClockSession",
                            "kind": "LinkedField",
                            "name": "b2CLockSession",
                            "plural": false,
                            "selections": [
                              (v21/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "currentCost",
                                "storageKey": null
                              },
                              (v10/*:: as any*/),
                              (v11/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "B2ClockReservationSubtype",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v4/*:: as any*/),
                      (v22/*:: as any*/),
                      (v23/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Hub",
                        "kind": "LinkedField",
                        "name": "hub",
                        "plural": false,
                        "selections": [
                          (v4/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "HubMeta",
                            "kind": "LinkedField",
                            "name": "meta",
                            "plural": false,
                            "selections": [
                              (v5/*:: as any*/),
                              (v24/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lat",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lng",
                                "storageKey": null
                              },
                              (v4/*:: as any*/),
                              (v25/*:: as any*/),
                              (v26/*:: as any*/),
                              (v27/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v28/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v29/*:: as any*/),
                  (v30/*:: as any*/),
                  (v31/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ty",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "permissions",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "myUtilizationGrants(input:{},pagination:{\"page\":0,\"pageSize\":1000})"
      },
      (v12/*:: as any*/),
      {
        "alias": "b2CLockReservations",
        "args": (v13/*:: as any*/),
        "concreteType": "LockReservationPage",
        "kind": "LinkedField",
        "name": "lockReservations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LockReservation",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              (v30/*:: as any*/),
              (v29/*:: as any*/),
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "subtype",
                "plural": false,
                "selections": [
                  (v17/*:: as any*/),
                  (v19/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v20/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "B2ClockSession",
                        "kind": "LinkedField",
                        "name": "b2CLockSession",
                        "plural": false,
                        "selections": [
                          (v4/*:: as any*/),
                          (v21/*:: as any*/),
                          (v6/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "paymentStatus",
                            "storageKey": null
                          },
                          (v10/*:: as any*/),
                          (v11/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "B2ClockSessionPayment",
                            "kind": "LinkedField",
                            "name": "activePayment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "amount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "stripeStatus",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "B2ClockReservationSubtype",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  (v22/*:: as any*/),
                  (v23/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Hub",
                    "kind": "LinkedField",
                    "name": "hub",
                    "plural": false,
                    "selections": [
                      (v4/*:: as any*/),
                      (v6/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HubMeta",
                        "kind": "LinkedField",
                        "name": "meta",
                        "plural": false,
                        "selections": [
                          (v4/*:: as any*/),
                          (v5/*:: as any*/),
                          (v24/*:: as any*/),
                          (v25/*:: as any*/),
                          (v26/*:: as any*/),
                          (v27/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v28/*:: as any*/)
                ],
                "storageKey": null
              },
              (v31/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "lockReservations(filter:{\"subtype\":\"B2C\"},orderBy:[{\"field\":\"STARTED_AT\",\"ordering\":\"DESC\"}],pagination:{\"page\":0,\"pageSize\":1000})"
      }
    ]
  },
  "params": {
    "cacheID": "795b4b1c97c07dd1f18165ac8db97c5c",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "b2CLockOutstandingSessions": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "B2ClockSession"
        },
        "b2CLockOutstandingSessions.amountCollected": (v32/*:: as any*/),
        "b2CLockOutstandingSessions.finalAmount": (v33/*:: as any*/),
        "b2CLockOutstandingSessions.id": (v34/*:: as any*/),
        "b2CLockReservations": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "LockReservationPage"
        },
        "b2CLockReservations.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "LockReservation"
        },
        "b2CLockReservations.nodes.contentNote": (v35/*:: as any*/),
        "b2CLockReservations.nodes.createdAt": (v36/*:: as any*/),
        "b2CLockReservations.nodes.deactivatedAt": (v37/*:: as any*/),
        "b2CLockReservations.nodes.id": (v34/*:: as any*/),
        "b2CLockReservations.nodes.lastUnlock": (v38/*:: as any*/),
        "b2CLockReservations.nodes.lastUnlock.nodes": (v39/*:: as any*/),
        "b2CLockReservations.nodes.lastUnlock.nodes.createdAt": (v36/*:: as any*/),
        "b2CLockReservations.nodes.lastUnlock.nodes.unlockedAt": (v37/*:: as any*/),
        "b2CLockReservations.nodes.note": (v35/*:: as any*/),
        "b2CLockReservations.nodes.space": (v40/*:: as any*/),
        "b2CLockReservations.nodes.space.configuration": (v41/*:: as any*/),
        "b2CLockReservations.nodes.space.frame": (v42/*:: as any*/),
        "b2CLockReservations.nodes.space.hub": (v43/*:: as any*/),
        "b2CLockReservations.nodes.space.hub.id": (v34/*:: as any*/),
        "b2CLockReservations.nodes.space.hub.meta": (v44/*:: as any*/),
        "b2CLockReservations.nodes.space.hub.meta.city": (v42/*:: as any*/),
        "b2CLockReservations.nodes.space.hub.meta.id": (v34/*:: as any*/),
        "b2CLockReservations.nodes.space.hub.meta.name": (v42/*:: as any*/),
        "b2CLockReservations.nodes.space.hub.meta.postalCode": (v42/*:: as any*/),
        "b2CLockReservations.nodes.space.hub.meta.services": (v45/*:: as any*/),
        "b2CLockReservations.nodes.space.hub.meta.street": (v42/*:: as any*/),
        "b2CLockReservations.nodes.space.hub.status": (v46/*:: as any*/),
        "b2CLockReservations.nodes.space.id": (v34/*:: as any*/),
        "b2CLockReservations.nodes.space.position": (v32/*:: as any*/),
        "b2CLockReservations.nodes.startedAt": (v36/*:: as any*/),
        "b2CLockReservations.nodes.subtype": (v47/*:: as any*/),
        "b2CLockReservations.nodes.subtype.__typename": (v42/*:: as any*/),
        "b2CLockReservations.nodes.subtype.b2CLockSession": (v48/*:: as any*/),
        "b2CLockReservations.nodes.subtype.b2CLockSession.activePayment": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "B2ClockSessionPayment"
        },
        "b2CLockReservations.nodes.subtype.b2CLockSession.activePayment.amount": (v32/*:: as any*/),
        "b2CLockReservations.nodes.subtype.b2CLockSession.activePayment.stripeStatus": {
          "enumValues": [
            "CANCELED",
            "PROCESSING",
            "REQUIRES_ACTION",
            "REQUIRES_CAPTURE",
            "REQUIRES_CONFIRMATION",
            "REQUIRES_PAYMENT_METHOD",
            "SUCCEEDED",
            "UNKNOWN"
          ],
          "nullable": true,
          "plural": false,
          "type": "StripePaymentIntentStatus"
        },
        "b2CLockReservations.nodes.subtype.b2CLockSession.amountCollected": (v32/*:: as any*/),
        "b2CLockReservations.nodes.subtype.b2CLockSession.finalAmount": (v33/*:: as any*/),
        "b2CLockReservations.nodes.subtype.b2CLockSession.id": (v34/*:: as any*/),
        "b2CLockReservations.nodes.subtype.b2CLockSession.paymentStatus": {
          "enumValues": [
            "REQUIRES_CAPTURE",
            "REQUIRES_ACTION",
            "COMPLETED"
          ],
          "nullable": true,
          "plural": false,
          "type": "B2ClockSessionPaymentStatus"
        },
        "b2CLockReservations.nodes.subtype.b2CLockSession.rentalStartedAt": (v37/*:: as any*/),
        "b2CLockReservations.nodes.subtype.b2CLockSession.status": {
          "enumValues": [
            "AWAITING_PAYMENT",
            "RENTAL_STARTED",
            "RENTAL_ENDED",
            "CANCELLED"
          ],
          "nullable": false,
          "plural": false,
          "type": "B2ClockSessionStatus"
        },
        "b2CLockReservations.nodes.subtype.createdByUserId": (v49/*:: as any*/),
        "b2CLockReservations.nodes.subtype.createdByUserId.id": (v34/*:: as any*/),
        "b2CLockReservations.nodes.subtype.user": (v50/*:: as any*/),
        "b2CLockReservations.nodes.subtype.user.id": (v34/*:: as any*/),
        "hubMeta": (v44/*:: as any*/),
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.id": (v34/*:: as any*/),
        "hubMeta.hub.status": (v46/*:: as any*/),
        "hubMeta.id": (v34/*:: as any*/),
        "hubMeta.name": (v42/*:: as any*/),
        "myUtilizationGrants": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "UtilizationGrantPage"
        },
        "myUtilizationGrants.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "UtilizationGrant"
        },
        "myUtilizationGrants.nodes.deactivatedAt": (v37/*:: as any*/),
        "myUtilizationGrants.nodes.id": (v34/*:: as any*/),
        "myUtilizationGrants.nodes.permissions": {
          "enumValues": [
            "END_RENTAL",
            "UNLOCK",
            "END_ON_OPEN"
          ],
          "nullable": false,
          "plural": true,
          "type": "UtilizationGrantPermission"
        },
        "myUtilizationGrants.nodes.reservation": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "LockReservation"
        },
        "myUtilizationGrants.nodes.reservation.contentNote": (v35/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.createdAt": (v36/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deactivatedAt": (v37/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.id": (v34/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.lastUnlock": (v38/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.lastUnlock.nodes": (v39/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.lastUnlock.nodes.createdAt": (v36/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.lastUnlock.nodes.unlockedAt": (v37/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.note": (v35/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space": (v40/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.configuration": (v41/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.frame": (v42/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub": (v43/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.id": (v34/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta": (v44/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.city": (v42/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.id": (v34/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.lat": (v51/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.lng": (v51/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.name": (v42/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.postalCode": (v42/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.services": (v45/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.street": (v42/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.status": (v46/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.id": (v34/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.position": (v32/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.startedAt": (v36/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype": (v47/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.__typename": (v42/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.b2CLockSession": (v48/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.b2CLockSession.amountCollected": (v32/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.b2CLockSession.currentCost": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Decimal"
        },
        "myUtilizationGrants.nodes.reservation.subtype.b2CLockSession.finalAmount": (v33/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.b2CLockSession.rentalStartedAt": (v37/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.createdByUserId": (v49/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.createdByUserId.id": (v34/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.user": (v50/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.user.id": (v34/*:: as any*/),
        "myUtilizationGrants.nodes.ty": {
          "enumValues": [
            "USER",
            "ORGANIZATION",
            "ANONYMOUS"
          ],
          "nullable": false,
          "plural": false,
          "type": "LockGrantType"
        },
        "oneHourEstimate": (v52/*:: as any*/),
        "twoHoursEstimate": (v52/*:: as any*/)
      }
    },
    "name": "lockB2CRentalsQuery",
    "operationKind": "query",
    "text": "query lockB2CRentalsQuery(\n  $hubName: String!\n  $oneHour: DateTime!\n  $twoHours: DateTime!\n) {\n  oneHourEstimate: b2CLockSessionFeeEstimate(input: {until: $oneHour})\n  twoHoursEstimate: b2CLockSessionFeeEstimate(input: {until: $twoHours})\n  hubMeta(by: {name: $hubName}) {\n    id\n    name\n    hub {\n      id\n      status\n    }\n  }\n  myUtilizationGrants(input: {}, pagination: {page: 0, pageSize: 1000}) {\n    nodes {\n      ...MyLocksTabsFragment\n    }\n  }\n  b2CLockOutstandingSessions {\n    id\n    finalAmount\n    amountCollected\n  }\n  b2CLockReservations: lockReservations(filter: {subtype: B2C}, orderBy: [{field: STARTED_AT, ordering: DESC}], pagination: {page: 0, pageSize: 1000}) {\n    nodes {\n      id\n      ...MyLocksTabsOwnedFragment\n    }\n  }\n}\n\nfragment LockCardFragment on UtilizationGrant {\n  id\n  ty\n  permissions\n  deactivatedAt\n  reservation {\n    id\n    startedAt\n    createdAt\n    deactivatedAt\n    contentNote\n    note\n    lastUnlock: unlockRequests(filter: {status: UNLOCKED}, orderBy: [{field: CREATED_AT, ordering: DESC}], pagination: {page: 0, pageSize: 1}) {\n      nodes {\n        unlockedAt\n        createdAt\n      }\n    }\n    subtype {\n      __typename\n      ... on B2BlockReservationSubtype {\n        createdByUserId {\n          id\n        }\n      }\n      ... on B2ClockReservationSubtype {\n        user {\n          id\n        }\n        b2CLockSession {\n          rentalStartedAt\n          currentCost\n          finalAmount\n          amountCollected\n        }\n      }\n    }\n    space {\n      id\n      frame\n      position\n      configuration\n      hub {\n        id\n        status\n        meta {\n          id\n          name\n          services\n          street\n          city\n          postalCode\n        }\n      }\n    }\n  }\n}\n\nfragment MyLocksTabsFragment on UtilizationGrant {\n  id\n  deactivatedAt\n  reservation {\n    id\n    deactivatedAt\n    contentNote\n    note\n    subtype {\n      __typename\n      ... on B2BlockReservationSubtype {\n        createdByUserId {\n          id\n        }\n      }\n      ... on B2ClockReservationSubtype {\n        user {\n          id\n        }\n      }\n    }\n    space {\n      id\n      frame\n      position\n      hub {\n        id\n        meta {\n          name\n          services\n          lat\n          lng\n        }\n      }\n    }\n  }\n  ...LockCardFragment\n}\n\nfragment MyLocksTabsOwnedFragment on LockReservation {\n  id\n  createdAt\n  startedAt\n  deactivatedAt\n  contentNote\n  note\n  subtype {\n    __typename\n    ... on B2BlockReservationSubtype {\n      createdByUserId {\n        id\n      }\n    }\n    ... on B2ClockReservationSubtype {\n      user {\n        id\n      }\n    }\n  }\n  space {\n    id\n    frame\n    position\n    hub {\n      id\n    }\n  }\n  ...OwnedLockCardFragment\n}\n\nfragment OwnedLockCardFragment on LockReservation {\n  id\n  startedAt\n  createdAt\n  deactivatedAt\n  contentNote\n  note\n  lastUnlock: unlockRequests(filter: {status: UNLOCKED}, orderBy: [{field: CREATED_AT, ordering: DESC}], pagination: {page: 0, pageSize: 1}) {\n    nodes {\n      unlockedAt\n      createdAt\n    }\n  }\n  subtype {\n    __typename\n    ... on B2ClockReservationSubtype {\n      b2CLockSession {\n        id\n        rentalStartedAt\n        status\n        paymentStatus\n        finalAmount\n        amountCollected\n        activePayment {\n          amount\n          stripeStatus\n        }\n      }\n    }\n  }\n  space {\n    id\n    frame\n    position\n    configuration\n    hub {\n      id\n      status\n      meta {\n        id\n        name\n        services\n        street\n        city\n        postalCode\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6540c5841a95d077b7803182c437285d";

export default node;
